import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { Nav, NavItem, Collapse, Tooltip } from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";
import { withRouter } from "react-router-dom";

import IntlMessages from "../../helpers/IntlMessages";

import {
  setContainerClassnames,
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems,
} from "../../redux/actions";

import menuItems from "../../constants/menu";
import { ScrollDetect } from "../../helpers/Utils";
import { END_POINT, END_POINT_SOCKET } from "../../constants/defaultValues";
import createSocket from "../../helpers/createSocket";
import axios from "axios";

const ROLESETTINGS = localStorage.getItem("roleSettings")
  ? JSON.parse(localStorage.getItem("roleSettings"))
  : null;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    const initialPath = props.location ? props.location.pathname : "";
    this.state = {
      selectedParentMenu: this.getParentByPath(initialPath) || "",
      viewingParentMenu: "",
      collapsedMenus: this.getInitialCollapsedMenus(initialPath),
      freePackage: false,
      proPackage: false,
      // platinumPackage: false,
      un_seen_mess: null,
      eInvoiceEnabled: false,
    };
    this.socket = createSocket();
  }

  isSubActive = (sub) => {
    const { location } = this.props;
    const currentPath = location ? location.pathname : "";
    if (!sub || !sub.to) return false;

    if (sub.to === currentPath) return true;

    // Submenu aliases / sub-routes
    if (sub.to === "/app/pages/ecommerce") {
      return (
        currentPath === "/app/pages/ecommerce" ||
        currentPath === "/app/pages/shopee" ||
        currentPath === "/app/pages/tiktok-shop" ||
        currentPath === "/app/pages/lazada" ||
        currentPath === "/app/pages/tiki" ||
        currentPath.startsWith("/app/pages/ecommerce-products")
      );
    }

    if (sub.to === "/app/pages/product") {
      return (
        currentPath === "/app/pages/product" ||
        currentPath.startsWith("/app/pages/product/") ||
        currentPath === "/app/pages/category" ||
        currentPath === "/app/pages/make-product"
      );
    }

    if (sub.to === "/app/dashboards/default") {
      return (
        currentPath === "/app/dashboards/default" ||
        currentPath === "/app/dashboards" ||
        currentPath.startsWith("/app/dashboards/")
      );
    }

    if (sub.to === "/app/pages/order") {
      return (
        currentPath === "/app/pages/order" ||
        currentPath === "/app/pages/invoice" ||
        currentPath.startsWith("/app/pages/order/")
      );
    }

    if (sub.subs && sub.subs.length > 0) {
      return sub.subs.some((third) => this.isThirdActive(third));
    }

    if (sub.to !== "/app" && currentPath.startsWith(sub.to + "/")) {
      return true;
    }

    return false;
  };

  isThirdActive = (thirdSub) => {
    const { location } = this.props;
    const currentPath = location ? location.pathname : "";
    if (!thirdSub || !thirdSub.to) return false;

    if (thirdSub.to === currentPath) return true;

    if (thirdSub.to === "/app/pages/cash-flow") {
      return (
        currentPath === "/app/pages/cash-flow" ||
        currentPath === "/app/pages/income" ||
        currentPath === "/app/pages/outcome"
      );
    }

    if (thirdSub.to === "/app/pages/stock") {
      return (
        currentPath === "/app/pages/stock" ||
        currentPath.startsWith("/app/pages/stock/") ||
        currentPath === "/app/pages/warehouse-export" ||
        currentPath === "/app/pages/warehouse-transfer"
      );
    }

    if (thirdSub.to !== "/app" && currentPath.startsWith(thirdSub.to + "/")) {
      return true;
    }

    return false;
  };

  getParentByPath = (pathname) => {
    if (!pathname) return menuItems[0]?.id || "";

    // 1. Check exact top-level items without subs first
    for (const item of menuItems) {
      if (!item.subs || item.subs.length === 0) {
        if (
          item.to === pathname ||
          (item.to !== "/app" && pathname.startsWith(item.to + "/"))
        ) {
          return item.id;
        }
      }
    }

    // 2. Check items with subs
    for (const item of menuItems) {
      if (item.subs && item.subs.length > 0) {
        for (const sub of item.subs) {
          if (this.isSubActive(sub)) {
            return item.id;
          }
          if (sub.subs && sub.subs.length > 0) {
            for (const third of sub.subs) {
              if (this.isThirdActive(third)) {
                return item.id;
              }
            }
          }
        }
      }
    }

    // 3. Fallback check on item.to
    for (const item of menuItems) {
      if (
        item.to === pathname ||
        (item.to !== "/app" && pathname.startsWith(item.to + "/"))
      ) {
        return item.id;
      }
    }

    return menuItems[0]?.id || "";
  };

  getInitialCollapsedMenus = (pathname) => {
    const collapsed = [];
    menuItems.forEach((item) => {
      if (item.subs) {
        item.subs.forEach((sub, index) => {
          if (sub.subs && sub.subs.length > 0) {
            const hasActiveChild = sub.subs.some((third) =>
              this.isThirdActive(third)
            );
            if (hasActiveChild) {
              collapsed.push(`${item.id}_${index}`);
            }
          }
        });
      }
    });
    return collapsed;
  };

  handleWindowResize = (event) => {
    if (event && !event.isTrusted) {
      return;
    }
    const { containerClassnames } = this.props;
    let nextClasses = this.getMenuClassesForResize(containerClassnames);
    this.props.setContainerClassnames(
      0,
      nextClasses.join(" "),
      this.props.selectedMenuHasSubItems
    );
  };

  handleDocumentClick = (e) => {
    const container = this.getContainer();
    let isMenuClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains("menu-button") ||
        e.target.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      (e.target.parentElement.classList.contains("menu-button") ||
        e.target.parentElement.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.parentElement &&
      e.target.parentElement.parentElement.classList &&
      (e.target.parentElement.parentElement.classList.contains("menu-button") ||
        e.target.parentElement.parentElement.classList.contains(
          "menu-button-mobile"
        ))
    ) {
      isMenuClick = true;
    }

    // Check if clicking the right sidebar toggle button
    const isRightSidebarButton =
      e.target.closest && e.target.closest(".setting");

    // Check if clicking inside right sidebar
    const isInsideRightSidebar =
      e.target.closest && e.target.closest(".sidebar-right");

    // If clicking toggle button, let it handle the toggle
    if (isRightSidebarButton) {
      return;
    }

    // If clicking inside left sidebar or menu button, return
    if (container.contains(e.target) || container === e.target || isMenuClick) {
      // But still close right sidebar if it's open and we're clicking inside left sidebar
      const { containerClassnames } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(" ").filter((x) => x !== "")
        : [];

      // If right sidebar is open and we're clicking inside left sidebar, close right sidebar
      if (
        !currentClasses.includes("main-right-hidden") &&
        !isInsideRightSidebar
      ) {
        let newClasses = currentClasses
          .filter((x) => x !== "")
          .concat(["main-right-hidden"])
          .filter((v, i, a) => a.indexOf(v) === i) // unique
          .join(" ");
        this.props.changeDefaultClassnames(newClasses);
      }
      return;
    }

    // If clicking inside right sidebar, only reset left sidebar state
    if (isInsideRightSidebar) {
      return;
    }

    this.setState({
      viewingParentMenu: "",
    });

    // Click is outside both sidebars - close everything
    const { containerClassnames } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(" ").filter((x) => x !== "")
      : [];

    let newClasses = "menu-default sub-hidden";

    // Preserve menu-mobile for proper mobile layout
    if (currentClasses.includes("menu-mobile")) {
      newClasses += " menu-mobile";
    }

    // Always add main-right-hidden when clicking outside to close right sidebar
    newClasses += " main-right-hidden";

    this.props.changeDefaultClassnames(newClasses);
  };

  getMenuClassesForResize = (classes) => {
    const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
    let nextClasses = classes.split(" ").filter((x) => x !== "");
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push("menu-mobile");
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter((x) => x !== "menu-mobile");
      if (
        nextClasses.includes("menu-default") &&
        !nextClasses.includes("menu-sub-hidden")
      ) {
        nextClasses.push("menu-sub-hidden");
      }
    } else {
      nextClasses = nextClasses.filter((x) => x !== "menu-mobile");
      if (
        nextClasses.includes("menu-default") &&
        nextClasses.includes("menu-sub-hidden")
      ) {
        nextClasses = nextClasses.filter((x) => x !== "menu-sub-hidden");
      }
    }
    return nextClasses;
  };

  getContainer = () => {
    return ReactDOM.findDOMNode(this);
  };

  toggle = () => {
    const hasSubItems = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubItems);
    const { containerClassnames, menuClickCount } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(" ").filter((x) => x !== "")
      : "";
    let clickIndex = -1;

    if (!hasSubItems) {
      if (
        currentClasses.includes("menu-default") &&
        (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
      ) {
        clickIndex = 1;
      } else if (
        currentClasses.includes("menu-sub-hidden") &&
        (menuClickCount === 2 || menuClickCount === 3)
      ) {
        clickIndex = 0;
      } else if (
        currentClasses.includes("menu-hidden") ||
        currentClasses.includes("menu-mobile")
      ) {
        clickIndex = 0;
      }
    } else {
      if (currentClasses.includes("menu-sub-hidden") && menuClickCount === 3) {
        clickIndex = 2;
      } else if (
        currentClasses.includes("menu-hidden") ||
        currentClasses.includes("menu-mobile")
      ) {
        clickIndex = 0;
      }
    }
    if (clickIndex >= 0) {
      if (clickIndex > 90) {
        this.props.setContainerClassnames(0, containerClassnames, hasSubItems);
      } else {
        this.props.setContainerClassnames(
          clickIndex,
          containerClassnames,
          hasSubItems
        );
      }
    }
  };

  addEvents = () => {
    document.addEventListener("click", this.handleDocumentClick, false);
  };

  removeEvents = () => {
    document.removeEventListener("click", this.handleDocumentClick, false);
  };

  setSelectedLiActive = (callback) => {
    const oldli = document.querySelectorAll(".sub-menu li.active");
    if (oldli && oldli.length > 0) {
      oldli.forEach((el) => el.classList.remove("active"));
    }

    const oldliSub = document.querySelectorAll(".third-level-menu li.active");
    if (oldliSub && oldliSub.length > 0) {
      oldliSub.forEach((el) => el.classList.remove("active"));
    }

    /* set selected parent menu */
    const selectedSublink = document.querySelector(
      ".third-level-menu a.active"
    );
    if (selectedSublink != null) {
      selectedSublink.parentElement.classList.add("active");
    }

    const selectedlink = document.querySelector(".sub-menu a.active");
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add("active");
      const parentNav = selectedlink.closest("ul[data-parent]");
      if (parentNav) {
        const parentId = parentNav.getAttribute("data-parent");
        if (parentId) {
          this.setState({ selectedParentMenu: parentId }, callback);
          return;
        }
      }
    }

    const currentPath = this.props.location ? this.props.location.pathname : "";
    const parentId = this.getParentByPath(currentPath);
    if (parentId) {
      this.setState({ selectedParentMenu: parentId }, callback);
    } else if (callback) {
      callback();
    }
  };

  setHasSubItemStatus = () => {
    const hasSubmenu = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubmenu);
    this.toggle();
  };

  getIsHasSubItem = () => {
    const { selectedParentMenu } = this.state;
    const menuItem = menuItems.find((x) => x.id === selectedParentMenu);
    if (menuItem)
      return menuItem && menuItem.subs && menuItem.subs.length > 0
        ? true
        : false;
    else return false;
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const currentPath = this.props.location.pathname;
      const currentParent = this.getParentByPath(currentPath);
      this.setState({
        viewingParentMenu: "",
        selectedParentMenu: currentParent || this.state.selectedParentMenu,
        collapsedMenus: this.getInitialCollapsedMenus(currentPath),
      });

      const { containerClassnames } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(" ").filter((x) => x !== "")
        : [];

      if (!currentClasses.includes("sub-hidden")) {
        let newClassList = ["menu-default", "sub-hidden"];
        if (currentClasses.includes("menu-mobile")) {
          newClassList.push("menu-mobile");
        }
        if (currentClasses.includes("main-right-hidden")) {
          newClassList.push("main-right-hidden");
        }
        this.props.changeDefaultClassnames(newClassList.join(" "));
      }

      this.setSelectedLiActive(this.setHasSubItemStatus);

      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
    this.addEvents();

    const initialPath = this.props.location ? this.props.location.pathname : "";
    const initialParent = this.getParentByPath(initialPath);
    if (initialParent && this.state.selectedParentMenu !== initialParent) {
      this.setState({
        selectedParentMenu: initialParent,
        collapsedMenus: this.getInitialCollapsedMenus(initialPath),
      });
    }

    this.setSelectedLiActive(this.setHasSubItemStatus);

    this.fetchEInvoiceCapability();
    ScrollDetect();
    // this.getExpired();

    this.socket.emit("join room", {
      room_id: localStorage.getItem("b"),
    });

    this.socket.emit("refresh-alert-data", {
      user_id: localStorage.getItem("b"),
    });

    this.socket.on("refresh-alert-data", (res) => {
      const { un_seen_mess } = res;

      this.setState({
        un_seen_mess: un_seen_mess,
      });
    });
  }

  componentWillUnmount() {
    this.removeEvents();
    window.removeEventListener("resize", this.handleWindowResize);
  }

  openSubMenu = (e, menuItem) => {
    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    this.props.changeSelectedMenuHasSubItems(hasSubMenu);

    if (!hasSubMenu) {
      this.setState({
        viewingParentMenu: selectedParent,
        selectedParentMenu: selectedParent,
      });
      // Hide menu when clicking menu without sub-items
      const { containerClassnames } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(" ").filter((x) => x !== "")
        : [];

      // Build new class list - closed state
      let newClassList = ["menu-default", "sub-hidden"];

      // Preserve mobile class
      if (currentClasses.includes("menu-mobile")) {
        newClassList.push("menu-mobile");
      }

      // Preserve right sidebar state
      if (currentClasses.includes("main-right-hidden")) {
        newClassList.push("main-right-hidden");
      }

      this.props.changeDefaultClassnames(newClassList.join(" "));
    } else {
      e.preventDefault();

      const { containerClassnames } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(" ").filter((x) => x !== "")
        : [];

      const isSubMenuCurrentlyVisible =
        (!currentClasses.includes("sub-hidden") &&
          !currentClasses.includes("menu-hidden")) ||
        currentClasses.includes("sub-show-temporary");

      const isCurrentParentActive =
        this.state.viewingParentMenu === selectedParent ||
        (this.state.viewingParentMenu === "" &&
          this.state.selectedParentMenu === selectedParent);

      // If submenu is ALREADY OPEN for this parent item -> Toggle CLOSE it
      if (isSubMenuCurrentlyVisible && isCurrentParentActive) {
        this.closeSubMenu();
        return;
      }

      if (!currentClasses.includes("menu-mobile")) {
        // Force show sub-menu by setting classes without sub-hidden
        let newClasses = "menu-default";
        if (currentClasses.includes("main-right-hidden")) {
          newClasses += " main-right-hidden";
        }
        this.props.changeDefaultClassnames(newClasses);
      } else {
        this.props.addContainerClassname(
          "sub-show-temporary",
          containerClassnames
        );
      }
      this.setState({
        viewingParentMenu: selectedParent,
      });
    }
  };

  // Close sub-menu on both Desktop and Mobile when clicking a sub-menu item
  closeSubMenu = () => {
    this.setState({
      viewingParentMenu: "",
    });

    const { containerClassnames } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(" ").filter((x) => x !== "")
      : [];

    // Build closed state class list
    let newClassList = ["menu-default", "sub-hidden"];

    // Preserve mobile class
    if (currentClasses.includes("menu-mobile")) {
      newClassList.push("menu-mobile");
    }

    // Preserve right sidebar state
    if (currentClasses.includes("main-right-hidden")) {
      newClassList.push("main-right-hidden");
    }

    this.props.changeDefaultClassnames(newClassList.join(" "));
  };

  // Close right sidebar when clicking a menu item inside it
  closeRightSidebar = () => {
    const { containerClassnames } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(" ").filter((x) => x !== "")
      : [];

    // Only close if right sidebar is open
    if (!currentClasses.includes("main-right-hidden")) {
      const newClasses = currentClasses
        .concat(["main-right-hidden"])
        .filter((v, i, a) => a.indexOf(v) === i) // unique
        .join(" ");
      this.props.changeDefaultClassnames(newClasses);
    }
  };

  toggleMenuCollapse = (e, menuKey) => {
    e.preventDefault();

    const { collapsedMenus } = this.state;
    if (collapsedMenus.indexOf(menuKey) > -1) {
      this.setState({
        collapsedMenus: collapsedMenus.filter((x) => x !== menuKey),
      });
    } else {
      collapsedMenus.push(menuKey);
      this.setState({
        collapsedMenus,
      });
    }
    return false;
  };

  filteredList = (menuItems) => {
    const { currentUser } = this.props;
    const businessType = localStorage.getItem("businessType");
    const isAdmin = localStorage.getItem("admin") === "true";
    // Check if user is parent account (user_id equals idParent means it's a parent/admin account)
    const userId = localStorage.getItem("user_id");
    const idParent = localStorage.getItem("b");
    const isParentAccount = userId && idParent && userId === idParent;
    // console.log('Sidebar businessType:', businessType);

    let filtered = menuItems;

    filtered = this.resolveMenuItems(filtered);
    if (currentUser) {
      filtered = filtered.filter(
        (x) => (x.roles && x.roles.includes(currentUser.role)) || !x.roles
      );
    } else if (ROLESETTINGS && !isAdmin && !isParentAccount) {
      // Only filter denied items for non-admin and non-parent users
      filtered = filtered.filter((x) => !x.denied);
    }

    // Filter by businessType
    filtered = filtered.filter((x) => {
      // Nếu menu item có giới hạn ngành hàng
      if (x.businessTypes && x.businessTypes.length > 0) {
        // Nếu user chưa có businessType -> ẩn luôn cho chắc
        if (!businessType) return false;

        // So sánh (chuyển về lowercase để tránh lỗi Fashion vs fashion)
        return x.businessTypes.includes(businessType.toLowerCase());
      }
      return true;
    });

    return filtered;
  };

  fetchEInvoiceCapability = () => {
    const tenantUserId = localStorage.getItem("user_id") || "";
    const tokenStr = localStorage.getItem("access_token");

    if (!tenantUserId || !tokenStr) return;

    axios
      .get(`${END_POINT}/api/einvoice/config?user_id=${tenantUserId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
        silent: true,
      })
      .then((res) => {
        this.setState({ eInvoiceEnabled: !!res.data?.data?.is_active });
      })
      .catch(() => {
        this.setState({ eInvoiceEnabled: false });
      });
  };

  resolveMenuItems = (items) => {
    const { eInvoiceEnabled } = this.state;

    return items
      .filter((item) => !item.requiresEInvoice || eInvoiceEnabled)
      .map((item) => {
        const resolvedItem = { ...item };
        delete resolvedItem.requiresEInvoice;

        if (item.conditionalEInvoiceSubmenu) {
          resolvedItem.label = eInvoiceEnabled
            ? item.label
            : item.disconnectedLabel || item.label;
          resolvedItem.subs = eInvoiceEnabled
            ? this.resolveMenuItems(item.subs || [])
            : undefined;
          delete resolvedItem.conditionalEInvoiceSubmenu;
          delete resolvedItem.disconnectedLabel;
          return resolvedItem;
        }

        if (item.subs) {
          resolvedItem.subs = this.resolveMenuItems(item.subs);
        }

        return resolvedItem;
      });
  };

  render() {
    const {
      selectedParentMenu,
      viewingParentMenu,
      collapsedMenus,
      un_seen_mess,
    } = this.state;

    return (
      <>
        <div className="sidebar">
          <div className="main-menu">
            <div className="scroll">
              <PerfectScrollbar
                options={{
                  suppressScrollX: true,
                  wheelPropagation: false,
                }}
              >
                <Nav vertical className="list-unstyled">
                  {menuItems &&
                    this.filteredList(menuItems).map((item) => {
                      const hasSubMenu =
                        item.subs &&
                        this.filteredList(item.subs).length > 0;
                      return (
                        <NavItem
                          key={item.id}
                          className={classnames({
                            active:
                              (selectedParentMenu === item.id &&
                                viewingParentMenu === "") ||
                              viewingParentMenu === item.id,
                            "has-sub-item": hasSubMenu,
                          })}
                        >
                          {item.newWindow ? (
                            <a
                              href={item.to}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <i className={item.icon} />{" "}
                              <IntlMessages id={item.label} />
                              {hasSubMenu && (
                                <i className="main-menu-has-sub-icon simple-icon-arrow-right" />
                              )}
                            </a>
                          ) : (
                            <NavLink
                              to={item.to}
                              onClick={(e) => this.openSubMenu(e, item)}
                              data-flag={item.id}
                              className="position-relative"
                            >
                              <i className={item.icon} />{" "}
                              {(item.id === "message" || item.id === "utilities") && un_seen_mess !== 0 && un_seen_mess !== null ? (
                                <span className="count_mess">
                                  {un_seen_mess}
                                </span>
                              ) : null}
                              <section className="position-relative">
                                <IntlMessages id={item.label} />
                              </section>
                              {hasSubMenu && (
                                <i className="main-menu-has-sub-icon simple-icon-arrow-right" />
                              )}
                            </NavLink>
                          )}
                        </NavItem>
                      );
                    })}
                </Nav>
              </PerfectScrollbar>
            </div>
          </div>

          <div className="sub-menu">
            <div className="scroll">
              <PerfectScrollbar
                options={{
                  suppressScrollX: true,
                  wheelPropagation: false,
                }}
              >
                {menuItems &&
                  this.filteredList(menuItems).map((item) => {
                    return (
                      <Nav
                        key={item.id}
                        className={classnames({
                          "d-block":
                            (this.state.selectedParentMenu === item.id &&
                              this.state.viewingParentMenu === "") ||
                            this.state.viewingParentMenu === item.id,
                        })}
                        data-parent={item.id}
                      >
                        {item.subs &&
                          this.filteredList(item.subs).map((sub, index) => {
                            return (
                              <NavItem
                                key={`${item.id}_${index}`}
                                className={classnames({
                                  "has-sub-item":
                                    sub.subs && sub.subs.length > 0,
                                  active: this.isSubActive(sub),
                                })}
                              >
                                {sub.newWindow ? (
                                  <a
                                    href={sub.to}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    onClick={this.closeSubMenu}
                                  >
                                    <i className={sub.icon} />{" "}
                                    <IntlMessages id={sub.label} />
                                  </a>
                                ) : sub.subs && sub.subs.length > 0 ? (
                                  <>
                                    <NavLink
                                      className={`rotate-arrow-icon opacity-50 ${
                                        collapsedMenus.indexOf(
                                          `${item.id}_${index}`
                                        ) === -1
                                          ? "collapsed"
                                          : ""
                                      }`}
                                      to={sub.to}
                                      id={`${item.id}_${index}`}
                                      onClick={(e) =>
                                        this.toggleMenuCollapse(
                                          e,
                                          `${item.id}_${index}`
                                        )
                                      }
                                    >
                                      <i className="simple-icon-arrow-down" />{" "}
                                      <IntlMessages id={sub.label} />
                                    </NavLink>

                                    <Collapse
                                      isOpen={
                                        collapsedMenus.indexOf(
                                          `${item.id}_${index}`
                                        ) > -1
                                      }
                                    >
                                      <Nav className="third-level-menu">
                                        {this.filteredList(sub.subs).map(
                                          (thirdSub, thirdIndex) => {
                                            return (
                                              <NavItem
                                                key={`${item.id}_${index}_${thirdIndex}`}
                                                className={classnames({
                                                  active:
                                                    this.isThirdActive(
                                                      thirdSub
                                                    ),
                                                })}
                                              >
                                                {thirdSub.newWindow ? (
                                                  <a
                                                    href={thirdSub.to}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    onClick={this.closeSubMenu}
                                                  >
                                                    <i
                                                      className={thirdSub.icon}
                                                    />{" "}
                                                    <IntlMessages
                                                      id={thirdSub.label}
                                                    />
                                                  </a>
                                                ) : (
                                                  <NavLink
                                                    to={thirdSub.to}
                                                    className="d-flex align-items-center"
                                                    isActive={() =>
                                                      this.isThirdActive(
                                                        thirdSub
                                                      )
                                                    }
                                                    onClick={
                                                      this.closeSubMenu
                                                    }
                                                  >
                                                    <i
                                                      className={thirdSub.icon}
                                                    />{" "}
                                                    <section className="position-relative">
                                                      <IntlMessages
                                                        id={thirdSub.label}
                                                      />
                                                    </section>
                                                  </NavLink>
                                                )}
                                              </NavItem>
                                            );
                                          }
                                        )}
                                      </Nav>
                                    </Collapse>
                                  </>
                                ) : (
                                  <NavLink
                                    to={sub.to}
                                    className="d-flex align-items-center"
                                    isActive={() => this.isSubActive(sub)}
                                    onClick={this.closeSubMenu}
                                  >
                                    <i className={sub.icon} />{" "}
                                    <section className="position-relative">
                                      <IntlMessages id={sub.label} />
                                      {sub.to === "/app/pages/message" &&
                                      un_seen_mess !== 0 &&
                                      un_seen_mess !== null ? (
                                        <span className="count_mess ml-1">
                                          {un_seen_mess}
                                        </span>
                                      ) : null}
                                    </section>
                                  </NavLink>
                                )}
                              </NavItem>
                            );
                          })}
                      </Nav>
                    );
                  })}
              </PerfectScrollbar>
            </div>
          </div>
        </div>


      </>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  } = menu;
  return {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    setContainerClassnames,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
  })(Sidebar)
);
